import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ["window", "trigger"];
  }
  initialize() {
    console.log("Showlogs controller initialized");
  }
  toggle() {
    console.log("Yep");
    const consoleWindow = this.windowTarget;
    const trigger = this.triggerTarget;
    consoleWindow.classList.contains("hidden") ? consoleWindow.classList.remove("hidden") : consoleWindow.classList.add("hidden");
    trigger.innerText.includes("Show") ? trigger.innerText = "Hide advanced logs" : trigger.innerText = "Show advanced logs"
  }
}
